import { BlocState } from 'src/app/shared/bloc/base-bloc';

export abstract class ContactUsPopupState extends BlocState {}
export class ContactUsSendedReplyState extends ContactUsPopupState {
  constructor(public message: string) {
    super();
  }
}
